
import React from 'react'
import UnavailabilityFormComponent from '../../../components/mobile/unAvailability/UnAvailability'

 const UnavailabilityForm = () => {
  return (
   <UnavailabilityFormComponent />
  )
}

export default UnavailabilityForm
